import { Api } from "./Api";

const api = new Api();
import {
	hammerEventsHandler,
	wordEnding,
	getObjectFromSessionStorage,
	setObjectToSessionStorage,
	insertDataToTicket,
	setTransformForTickets,
	getZonePropertiesById,
} from "../utils";

export class DefaultClass {
	constructor() {
		this.$cartCount = $(".js-count");
		this.isDesktop = window.matchMedia("(min-width: 768px)");
		this.$panZoomZoomIn = null;
		this.$panZoomZoomOut = null;
		this.$panZoomZoomReset = null;
		this.$svg = null;
		this.$elements = null;
		this.subscriptionCount = null;
		this.storageArr = [];
		this.$modal = $("#js-popup-modal");
		this.$modalContent = this.$modal.find(".modal-body");
		this.$subscriptionItems = $(".subscription__item");
		this.eventId = null;
		this.subEventId = null;
		this.subUnittId = null;
		this.$placesSvg = null;
		this.$back = null;
		this.$previousSvg = null;
		this.$placesPrices = null;
		this.$placesLegend = null;
		this.$placesInfo = null;
		this.$placesFooter = null;
		this.$placesFixed = null;
		this.$placesOpen = null;
		this.$placesBuy = null;
		this.arrayOfPlaces = [];
		this.isSectors = false;
		this.$tooltip = null;
		this.$placesSum = null;
		this.subSeatCount = null;
	}

	init() {}

	getPrices(view_id = 0) {
		return api.getPrices(this.subEventId, view_id);
	}

	setPanZoom(svg) {
		let isEnableZoom = true;

		if (this.isDesktop.matches) {
			isEnableZoom = false;
		}
		this.panZoom = svgPanZoom(svg, {
			zoomEnabled: true,
			mouseWheelZoomEnabled: isEnableZoom,
			dblClickZoomEnabled: false,
			customEventsHandler: hammerEventsHandler,
		});
		this.panZoom.fit();
		this.panZoom.center();

		this.$panZoomZoomIn.on("click", () => {
			this.panZoom.zoomIn();
		});

		this.$panZoomZoomOut.on("click", () => {
			this.panZoom.zoomOut();
		});

		this.$panZoomZoomReset.on("click", () => {
			this.panZoom.resetZoom();
			this.panZoom.resetPan();
		});

		$(window).resize(() => {
			this.panZoom.resize();
			this.panZoom.fit();
			this.panZoom.center();
		});

		return false;
	}

	getCartCount() {
		return api.getCartCount(this.eventId).then(res => {
			if (!res.length) {
				this.$cartCount.text(0).hide();
				return false;
			}
			let count = 0;
			$.each(res, (index, order) => {
				const countTickets = order.count_tickets;
				count += countTickets;
			});

			if (count) {
				this.$cartCount.text(count).show();
			} else {
				this.$cartCount.hide();
			}
			return res;
		});
	}

	getSubscriptionCartCount(needOverlay) {
		this.arrayOfPlaces = [];
		return api
			.getSubscriptionCartCount(this.eventId, this.subEventId, needOverlay)
			.then(res => {
				$.each(res, (index, elem) => {
					this.arrayOfPlaces.push(elem);
				});
			})
			.then(() => {
				this.subSeatCount = this.subscriptionCount;
				$.each(this.arrayOfPlaces, (index, elem) => {
					if (Number(elem.event_id) === this.subEventId) {
						this.subSeatCount--;
					}
				});
				this.updateSeatCount(this.subEventId);
			});
	}

	updateSeatCount(eventId) {
		const item = $(`.subscription__item[data-event=${eventId}]`);
		const count = item.find(".js-subscription-seat-count");
		count.text(this.subSeatCount);
	}

	addActionToBack() {
		this.$back.on("click", () => {
			this.$placesSvg.html(this.$previousSvg);
			this.$back.hide();
			this.$placesPrices.hide();
			this.$placesLegend.hide();
			this.$placesInfo.hide();
			this.$svg = $("#svg");
			this.$elements = this.$svg.find("g[mode]");
			this.addActionToSector();
		});
	}

	setDefaultColor(elements) {
		$.each(elements, (index, element) => {
			$(element).addClass("default");
		});
	}

	setColorToPlace(res) {
		$.each(res.prices, (index, element) => {
			const id = element.id;
			const name = element.name;
			const price = element.price;
			const zoneId = element.z;
			const zone = getZonePropertiesById(zoneId, res.zones);
			const color = zone.color;
			const selector = $(`#${id}`);
			selector.data("available", "true");
			selector.data("name", name);
			selector.attr("zone", zoneId);
			selector.data("price", price);
			selector.removeClass("default").addClass("active");
			selector.find("rect").css("fill", color);
			selector.find("ellipse").css("fill", color);
			selector.find("circle").css("fill", color);
		});
	}

	setPricesLabelToPlace(zones) {
		this.$placesPrices.html("");
		zones = zones.sort((a, b) => {
			return a.price - b.price;
		});
		for (let i = 0; i < zones.length; i++) {
			const zone = zones[i].zone;
			const color = zones[i].color;
			const price = zones[i].price;
			const available = this.$svg.find(`g[zone="${zone}"]`).length;
			const placesPrice = `<label   class="places__price">
<input class="places__input" type="checkbox" data-color="${color}" data-zone="${zone}">
<span class="places__price-content"><span class="places__price-color" style="background-color: ${color} "></span>
<span>${price} руб., свободно ${available} ${wordEnding(available, [
				"билет",
				"билета",
				"билетов",
			])}</span></span>
</label>`;
			this.$placesPrices.append(placesPrice);
		}
	}

	addActionToPrice() {
		$(".places__price input").change(e => {
			const input = $(e.currentTarget);
			if (input.is(":checked")) {
				let color = input.data("color");
				if (!this.isDesktop.matches) {
					color = "#000";
				}
				input.next().css("border-color", color);
			} else {
				input.next().css("border-color", "");
			}
			if ($("input[data-zone]:checked").length === 0) {
				$("g.active").removeClass("gray");
			} else {
				$("g.active").each((i, elem) => {
					const el = $(elem);
					const myPriceStr = String(el.attr("zone"));
					if (myPriceStr) {
						const myPrice = myPriceStr.split(",");
						let hideFlag = 0;

						for (let j = 0; j < myPrice.length; j++) {
							if (!$(`input[data-zone="${parseInt(myPrice[j])}"]`).is(":checked")) {
								hideFlag++;
							}
						}
						if (hideFlag === myPrice.length) {
							el.addClass("gray");
						} else {
							el.removeClass("gray");
						}
					}
				});
			}
		});
		$(".places__price").hover(
			e => {
				const color = $(e.currentTarget)
					.find(".places__price-color")
					.css("background-color");
				$(e.currentTarget)
					.find(".places__price-content")
					.css("border-color", color);
			},
			e => {
				const input = $(e.currentTarget).find("input");
				if (input.is(":checked")) {
					$(e.currentTarget)
						.find(".places__price-content")
						.css("border-color", input.data("color"));
				} else {
					$(e.currentTarget)
						.find(".places__price-content")
						.css("border-color", "");
				}
			},
		);

		$(".places__price").on("click", e => {
			const element = $(e.currentTarget);
			if (element.find(".places__price-content").css("border-color") !== "") {
				element.find(".places__price-content").css("border-color", "");
			}
		});
	}

	addActionToPlaces() {
		this.$elements.on("click", e => {
			const element = $(e.currentTarget);
			const sid = element.attr("id");
			const isPack = element.data("ispack");
			if (isPack) {
				element.data("available", "true");
			}
			const isCart = element.data("available");
			if (isCart === "true") {
				if (!isPack) {
					element.data("available", "false");
				}
				this.addToSubscriptionCart(sid);
			} else if (isCart === "false") {
				element.data("available", "true");
				this.removeFromSubscriptionCart(sid);
			}
		});
		if (!this.isSectors) {
			this.$elements.on("mouseout", () => {
				this.$tooltip.hide();
				this.$tooltip.css({ left: 0, top: 0 });
			});
			this.$elements.on("mouseover", e => {
				const element = $(e.currentTarget);
				const price = element.data("price");
				const name = element.data("name");
				if (this.isDesktop.matches) {
					// this.addTooltip(element, price, name);
				}
			});
		}
	}

	addTooltip(activeSector, price, name) {
		const clientX =
			activeSector[0].getBoundingClientRect().x ||
			activeSector[0].getBoundingClientRect().left;
		const clientY =
			activeSector[0].getBoundingClientRect().y ||
			activeSector[0].getBoundingClientRect().top;
		const y = clientY - this.$tooltip.outerHeight() - 40;
		const x = clientX - this.$tooltip.outerWidth() / 2;

		if (price && price.length > 1) {
			price = price.split(",");
			price = price.sort((a, b) => {
				return a - b;
			});
		}

		this.$tooltip.find(".tooltip-info__price").text(`${price}`);
		this.$tooltip.find(".tooltip-info__name").text(`${name}`);
		this.$tooltip.css({ left: x, top: y });
		this.$tooltip.show();
	}

	actionAfterChooseSector(svg) {
		this.$placesSvg.html(svg);
		this.$svg = $("#svg");
		this.$elements = this.$svg.find("g[mode]");
		this.setPanZoom(this.$svg[0]);
		this.$back.show();
		this.addActionToBack();
	}

	getPricesAfterChooseSector(viewId) {
		this.getPrices(viewId)
			.then(response => {
				this.setDefaultColor(this.$elements);
				this.setColorToPlace(response.prices);
				this.setPricesLabelToPlace(this.zones);
				this.addActionToPrice();
			})
			.then(() => {
				$.each(this.arrayOfPlaces, (index, elem) => {
					if (Number(elem.event_id) === this.subEventId) {
						const selector = $(`#${elem.sid}`);
						selector.addClass("in-cart").data("available", "false");
					}
				});
				if (Number($("#js-places-choose").text()) === this.subscriptionCount) {
					this.$elements.addClass("inactive");
				}
				this.addActionToPlaces();
			});
	}

	addActionToSector() {
		$.each(this.$elements, (index, elem) => {
			const sector = $(elem);
			const viewId = sector.attr("view_id");
			sector.on("click", () => {
				this.$previousSvg = this.$svg;
				const svgLocal = localStorage.getItem(`${this.subUnittId}_${viewId}`);
				if (svgLocal) {
					this.actionAfterChooseSector(svgLocal);
					this.getPricesAfterChooseSector(viewId);
				} else {
					this.getPlacesSvg(viewId)
						.then(response => {
							this.actionAfterChooseSector(response.svg);
							localStorage.setItem(`${this.subUnittId}_${viewId}`, response.svg);
						})
						.then(() => {
							this.getPricesAfterChooseSector(viewId);
						});
				}
				this.$placesLegend.show();
				this.$placesInfo.show();
				this.$placesPrices.show();
			});
		});
	}

	updateSum(places) {
		const sum = this.$placesSum.find(".js-sum");
		sum.text("");
		$.each(places, (index, elem) => {
			sum.text(Number(sum.text()) + elem.price);
		});
	}

	addToSubscriptionCart(sid) {
		api.addToSubscriptionCart(this.eventId, this.subEventId, sid)
			.then(res => {
				if (res.places) {
					$(".tickets_subscription .js-tickets-items").html("");

					$.each(res.places, (index, elem) => {
						$(`#${elem.sid}`).addClass("in-cart");
						const ticket = insertDataToTicket(elem, false, false);
						console.log($(ticket));

						$(ticket)
							.find(".js-tickets-remove")
							.removeClass("js-tickets-remove")
							.addClass("js-tickets-sub-remove");
						$(".tickets_subscription .js-tickets-items").append(ticket);
					});
					this.updateSum(res.places);
					$("#js-places-choose").text(Number($("#js-places-choose").text()) + 1);
					if (Number($("#js-places-choose").text()) >= this.subscriptionCount) {
						this.$elements.addClass("inactive");
					}
					if (Number($("#js-places-choose").text()) === this.subscriptionCount) {
						this.$placesBuy.removeClass("inactive");
					}

					if (!this.$placesFooter.hasClass("active")) {
						this.$placesFooter.addClass("active");
					}
					if (!this.$placesOpen.hasClass("active")) {
						this.$placesOpen.addClass("active");
					}
					if (!this.$placesFixed.hasClass("active")) {
						this.$placesFixed.addClass("active");
					}
					if (!$("#js-popup-modal").hasClass("active")) {
						$("#js-popup-modal").addClass("hide-close");
					}
					if (!$(".js-places-open").hasClass("visible")) {
						$(".js-places-open").addClass("visible");
					}
					const count = $(".js-places-open .js-count");
					count.text(Number(count.text()) + 1);
					const color = $(`#${sid}`).data("color");
					const storageObject = { sid, color };
					const getStorage = getObjectFromSessionStorage(this.subEventId);
					if (getStorage) {
						getStorage.push(storageObject);
						setObjectToSessionStorage(this.subEventId, getStorage);
					} else {
						this.storageArr.push(storageObject);
						setObjectToSessionStorage(this.subEventId, this.storageArr);
					}
				}
			})
			.then(() => {
				this.getSubscriptionCartCount();

				if (this.isDesktop.matches) {
					setTransformForTickets();
				}
			});
	}

	removeFromSubscriptionCart(sid) {
		console.log(sid);
		api.removeFromSubscriptionCart(this.eventId, this.subEventId, sid)
			.then(res => {
				if (res.error) {
					window.location.reload();
				}

				$(`#${sid}`).removeClass("in-cart");
				$(`.tickets__item[data-place="${sid}"]`).remove();
				let count = Number($("#js-places-choose").text()) - 1;
				if (count <= 0) {
					count = 0;
					$(".js-places-open").removeClass("visible");
				}
				$("#js-places-choose").text(count);
				$(".js-places-open .js-count").text(count);
				if (Number($("#js-places-choose").text()) < this.subscriptionCount) {
					this.$elements.removeClass("inactive");
				}
				if (Number($("#js-places-choose").text()) !== this.subscriptionCount) {
					this.$placesBuy.addClass("inactive");
				}
				this.updateSum(res.places);
				if (Array.isArray(res.places) && !res.places.length) {
					this.$placesFooter.removeClass("active");
					this.$placesOpen.removeClass("active");
					$(".places__fixed").removeClass("active");
					$("#js-popup-modal").removeClass("hide-close");
					this.arrayOfPlaces = [];
				}

				$(".places-description-ticket").text(
					wordEnding(res.count, ["билет", "билета", "билетов"]),
				);
				const getStorage = getObjectFromSessionStorage(this.subEventId);
				for (let i = 0; i < getStorage.length; i++) {
					if (getStorage[i].sid === sid) {
						const colorStorage = getStorage[i].color;
						const color = $(`.places__input[data-color="${colorStorage}"]`).data(
							"color",
						);
						$(`#${sid}`).removeClass("disabled");
						$(`#${sid}`)
							.find("rect")
							.css("fill", color);
						$(`#${sid}`)
							.find("ellipse")
							.css("fill", color);
						$(`#${sid}`)
							.find("circle")
							.css("fill", color);
						getStorage.splice(i, 1);
					}
				}
				setObjectToSessionStorage(this.subEventId, getStorage);
			})
			.then(() => {
				this.getSubscriptionCartCount();

				if (this.isDesktop.matches) {
					setTransformForTickets();
				}
			});
	}

	addSubscriptionEvent() {
		return api.addEvent(this.eventId, this.subEventId);
	}

	addAllEvents() {
		return api.addAllEvents(this.eventId);
	}

	removeAllEvents() {
		return api.removeAllEvents(this.eventId);
	}

	removeSubscriptionEvent() {
		return api.removeEvent(this.eventId, this.subEventId);
	}

	removeSubscriptionEventSids() {
		return api.removeEventSids(this.eventId, this.subEventId);
	}

	getPlaces() {
		return api.getPlaces(this.subEventId);
	}

	getPlacesSvg(view_id) {
		return api.getPlacesSvg(this.subEventId, view_id);
	}

	getSubscriptionChange(name) {
		return api.getSubscriptionChange(this.eventId, name);
	}

	getChangeSeats() {
		return api.getChangeSeats(this.eventId, this.subEventId);
	}
}
